import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Trophy: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.00606 1.00199L1.00806 1.00826V5.50814V10.008H2.00406H3.00006V6.50399V2.99999H3.9951H4.99011L4.9988 6.79799C5.00828 10.9505 5.00178 10.7506 5.15053 11.4551C5.60737 13.6188 7.09758 15.4708 9.11365 16.3804C9.62876 16.6128 10.4234 16.8529 10.8661 16.9099L10.9921 16.9262V18.9631V21H7.99206H4.99206V21.996V22.992H12.0001H19.0081V21.996V21H16.0081H13.0081V18.9631V16.9262L13.1341 16.9099C13.3845 16.8777 13.8198 16.7692 14.1961 16.6451C15.962 16.0632 17.4061 14.8193 18.2499 13.1532C18.6077 12.4468 18.8304 11.7256 18.9518 10.88C18.9885 10.6244 18.9935 10.2157 19.0013 6.79799L19.01 2.99999H20.005H21.0001V6.50399V10.008H21.9961H22.9921V5.51195V1.01594L20.0001 0.999955C17.2724 0.985411 7.93033 0.986515 3.00606 1.00199ZM7.0141 6.78599C7.02085 10.2739 7.02474 10.5899 7.06354 10.8C7.19617 11.518 7.45719 12.1844 7.82408 12.7415C8.2634 13.4086 8.91154 14.0068 9.60382 14.3842C11.384 15.3545 13.596 15.1503 15.1561 13.8715C15.364 13.701 15.7487 13.3121 15.9152 13.104C16.422 12.4706 16.7751 11.6741 16.9366 10.8C16.9754 10.5899 16.9793 10.2739 16.986 6.78599L16.9933 2.99999H12.0001H7.00678L7.0141 6.78599Z'
        fill={fill}
      />
    </svg>
  )
}
export default Trophy
